import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ProjectService } from 'src/app/services/project.service';
import { Project } from 'src/app/shared/models/project.model';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrl: './projects.component.scss',
    standalone: false
})
export class ProjectsComponent implements OnInit {
	projectsObserve!: Observable<Project[]>;
	projects: Project[] = [];
	conversationPage = false;
	isShowMenu = false;
	currentClient: any = null;

	constructor(private authService: AuthService, public projectService: ProjectService, private router: Router, private cdRef: ChangeDetectorRef) {}

	async ngOnInit() {
		this.currentClient = this.authService.currentClientValue;

		await this.projectService.getProjects();
		this.projectsObserve = this.projectService.projects$;

		this.projectsObserve.subscribe(projs => {
			this.projects = projs;
		});

		this.projectService.leftSideBarEvent$.subscribe((show: boolean) => {
			this.isShowMenu = show;
			this.conversationPage = show;

			this.cdRef.detectChanges();
		});

		this.projectService.hideLeftSideBar$.subscribe((shouldHide) => {
			this.conversationPage = shouldHide;
	
			this.cdRef.detectChanges();
		});
	}

	toggleSidebar(event: boolean) {
		this.isShowMenu = event;
	}
	
	ngDoCheck(): void {
		if (this.projects.length > 0) {
			if (this.router.url === '/projects') {
				this.router.navigate(['projects/' + this.projects[0].id]);
			}
		}
	}
}
